"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidAddressResultType = exports.TradeType = exports.TxStatus = exports.TxType = exports.FeeDataKey = exports.ethereum = exports.cosmos = exports.bitcoin = void 0;
const base_1 = require("../base");
const bitcoin = __importStar(require("./bitcoin"));
exports.bitcoin = bitcoin;
const cosmos = __importStar(require("./cosmos"));
exports.cosmos = cosmos;
const ethereum = __importStar(require("./ethereum"));
exports.ethereum = ethereum;
var FeeDataKey;
(function (FeeDataKey) {
    FeeDataKey["Slow"] = "slow";
    FeeDataKey["Average"] = "average";
    FeeDataKey["Fast"] = "fast";
})(FeeDataKey = exports.FeeDataKey || (exports.FeeDataKey = {}));
var TxType;
(function (TxType) {
    TxType["Send"] = "send";
    TxType["Receive"] = "receive";
    TxType["Contract"] = "contract";
    TxType["Unknown"] = "unknown";
})(TxType = exports.TxType || (exports.TxType = {}));
var TxStatus;
(function (TxStatus) {
    TxStatus["Confirmed"] = "confirmed";
    TxStatus["Pending"] = "pending";
    TxStatus["Failed"] = "failed";
    TxStatus["Unknown"] = "unknown";
})(TxStatus = exports.TxStatus || (exports.TxStatus = {}));
var TradeType;
(function (TradeType) {
    TradeType["Trade"] = "trade";
    TradeType["Refund"] = "refund";
})(TradeType = exports.TradeType || (exports.TradeType = {}));
var ValidAddressResultType;
(function (ValidAddressResultType) {
    ValidAddressResultType["Valid"] = "valid";
    ValidAddressResultType["Invalid"] = "invalid";
})(ValidAddressResultType = exports.ValidAddressResultType || (exports.ValidAddressResultType = {}));
